'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _formatPhoneNumber = require('../../../utils/formatPhoneNumber');

var _Contacts = require('../Contacts/Contacts.scss');var _Contacts2 = _interopRequireDefault(_Contacts);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var HiddenContact = function (_Component) {_inherits(HiddenContact, _Component);function HiddenContact() {var _temp, _this, _ret;_classCallCheck(this, HiddenContact);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isShownData: false }, _this.


    handleOpenContact = function () {
      var status = !_this.state.isShownData;
      _this.setState({ isShownData: status });
      _this.props.openContactHandler(status);
    }, _temp), _possibleConstructorReturn(_this, _ret);}HiddenContact.prototype.

  render = function render() {var _cx;var _props =
    this.props,isShownPhone = _props.isShownPhone,contact = _props.contact;var
    name = contact.name,email = contact.email,phone = contact.phone;

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          _Contacts2.default.contactsBlock,
          _Contacts2.default.secondaryContact, (_cx = {}, _cx[
          _Contacts2.default.openBlock] = this.state.isShownData, _cx)) },


        _react2.default.createElement('div', { className: (0, _classnames2.default)(_Contacts2.default.contactRow, _Contacts2.default.clickableArea), onClick: this.handleOpenContact },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: (0, _classnames2.default)('icon icon-user', _Contacts2.default.iconsIndent, _Contacts2.default.textAlignment) }),
            _react2.default.createElement('span', { className: _Contacts2.default.textAlignment }, name)),

          _react2.default.createElement('span', { className: (0, _classnames2.default)('icon-arrow-down', _Contacts2.default.chevron) })),









        isShownPhone ?
        _react2.default.createElement('div', { className: this.props.phoneButtonClassName }, '\u202A' +
          (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(phone))) :


        _react2.default.createElement('div', { className: this.props.phoneButtonClassName, onClick: this.props.phoneButtonOnClick },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _Contacts2.default.iconsIndent) }),
          this.props.translate('contacts', 'showNumber'))));




  };return HiddenContact;}(_react.Component);exports.default = HiddenContact;


HiddenContact.propTypes = {
  contact: _propTypes2.default.object,
  openContactHandler: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  isShownPhone: _propTypes2.default.bool,
  phoneButtonClassName: _propTypes2.default.string,
  phoneButtonOnClick: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/HiddenContact/HiddenContact.js
// module id = 2790
// module chunks = 0